import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaRegUserCircle } from "react-icons/fa";
import { baseurl } from "../../helper/Baseurl";
import noCoursesImage from "../../assets/images/png/Search.png"; 
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"; 
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../context/TranslationContext"; 
const ArchiveButton = () => {
     const { translations , language} = useTranslation(); 
      const isArabic = language === "ar";
  

  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1); 
  const coursesPerPage = 8; 
  const generateImageUrl = (coverImageUrl) => {
    const baseImageUrl = `${baseurl}uploads/file/download/`;
    return coverImageUrl
      ? `${baseImageUrl}${coverImageUrl}`
      : "default-image-path"; 
  };

    const openShowcourse = (courseId) => {
      navigate(`/Showcourse/${courseId}`);
    };
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(`${baseurl}my-courses`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        const validCourses = response.data.filter(
          (course) => course && course.coverImageUrl && course.progressPercentage === 100
        );

        const updatedCourses = validCourses.map((course) => ({
          ...course,
          imageUrl: generateImageUrl(course.coverImageUrl),
        }));

        setCourses(updatedCourses);
      } catch (error) {
        console.error("Error fetching courses data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (courses.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center p-4 mt-[-10%]">
        <img
          src={noCoursesImage}
          alt="No courses available"
          className="w-60 h-60 object-cover mb-10"
        />
        <p className="text-lg text-gray-700 mt-0">
     
     {translations.ArchiveButtoncourses}
        </p>
      </div>
    );
  }

  const indexOfLastCourse = currentPage * coursesPerPage;
  const indexOfFirstCourse = indexOfLastCourse - coursesPerPage;
  const currentCourses = courses.slice(indexOfFirstCourse, indexOfLastCourse);
  const totalPages = Math.ceil(courses.length / coursesPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="p-4">
      <div className="flex flex-wrap mb-4">
        {currentCourses.map((course, idx) => (
          <div
            key={idx}
            className="w-full lg:w-1/4 sm:w-2/4  p-2"
            onClick={() => openShowcourse(course.id)}
          >
            <div className="bg-white rounded-lg shadow-md p-3 hover:shadow-lg transition-shadow duration-300">
              <img
                src={course.imageUrl}
                alt={course.title}
                className="w-full  object-cover rounded-lg mb-3"
              />
              <h3
                className="text-lg font-semibold mb-1 text-gray-800"
                style={{ fontFamily: "Tajwal, sans-serif" }}
              >
                {course.title}
              </h3>
              <p
                className="text-gray-600 text-xs"
                style={{
                  fontFamily: "Tajwal, sans-serif",
                  textAlign: "justify",
                  lineHeight: "1.5",
                  marginBottom: "8px",
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 1,
                }}
              >
                {course.description}
              </p>
              <div className="flex items-center text-sm text-gray-600">
                <FaRegUserCircle className="text-gray-600 ml-2" />
                <p
                  className="text-sm"
                  style={{ fontFamily: "Tajwal, sans-serif" }}
                >
                  {course.createdBy}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="mt-4">
        <ul className="flex justify-center space-x-2 items-center">
          <li>
            <button
              className="px-3 py-1 rounded-full text-primary-blue hover:bg-gray-100 transition-all"
              onClick={() =>
                currentPage > 1 && handlePageChange(currentPage - 1)
              }
              disabled={currentPage === 1}
            >
                  {isArabic ?    <FaArrowRight /> :    <FaArrowLeft />}
            </button>
          </li>
          {Array.from({ length: totalPages }, (_, index) => (
            <li key={index}>
              <button
                className={`px-3 py-1 rounded-full ${
                  currentPage === index + 1
                    ? "bg-primary-blue text-white"
                    : "text-gray-700 hover:bg-gray-200"
                } transition-all`}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </button>
            </li>
          ))}
          <li>
            <button
              className="px-3 py-1 rounded-full text-primary-blue hover:bg-gray-100 transition-all"
              onClick={() =>
                currentPage < totalPages && handlePageChange(currentPage + 1)
              }
              disabled={currentPage === totalPages}
            >
                {isArabic ?      <FaArrowLeft />  :    <FaArrowRight />}
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ArchiveButton;
